// API Reference: https://www.wix.com/velo/reference/api-overview/introduction
// “Hello, World!” Example: https://learn-code.wix.com/en/article/1-hello-world

import wixLocation from 'wix-location';

$w.onReady(function () {

    setTimeout(() => {

        wixLocation.to("https://www.interhaptics.com");

    }, 5000);

});